import React, { Fragment, useEffect, useState } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Checkbox,
  // Tooltip,
} from "@mui/material";
import { Select as AntSelect } from "antd";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { MODE } from "../../constants/enums";
import { useSelector } from "react-redux";
import { Tooltip } from "antd";
import EmptyList from "../common/EmptyList";
import { checkPermissions, toastMessage } from "../../helper";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ProjectsAndOffsetsDetailedView from "./ProjectsAndOffsetsDetailedView";
import { getOffsetListService } from "../../services/offsetService";
import TableFilterSort from "../common/TableFilterSort";
import ProjectsAndOffsetsStatusUpdate from "./ProjectsAndOffsetsStatusUpdate";
import SkeletonLoader from "../common/Skeletons/TableSkeleton/TableSkeletonLoader";

const ProjectAndOffsetsList = () => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const currentBusinessUnit = useSelector(
    (state: any) => state.auth.currentBusinessUnit
  );
  const [offsetsList, setOffsetsList] = useState<any>();
  const [searchText, setSearchText] = useState("");

  const [mode, setMode] = useState(MODE.PLAIN);
  const [selectedCount, setSelectedCount] = useState(0);
  const [offsetsCount, setOffsetsCount] = useState(0);
  const [eachOffsetData, setEachOffsetData] = useState({} as any);
  const { Option } = AntSelect;
  const [updateStatusFormData, setUpdateStatusFormData] = useState({
    retiredFrom: null,
    retiredTo: null,
    transferredDate: null,
    comments: "",
    attachments: [],
    toValue: null,
    fromValue: null,
    certificateNumber: "",
    retirementDate: null,
  });
  const [statusUpdateSelectedIndex, setStatusUpdateSelectedIndex] = useState();
  const [statusUpdateSelectedListIndex, setStatusUpdateSelectedListIndex] =
    useState();
  const [toStatus, setToStatus] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [controller, setController] = useState<any>({
    page: 0,
    limit: 10,
    sortBy: null,
    sortOrder: null,
    filters: {},
    columns: {
      "Project Id": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Project type": {
        type: "string",
        hasSortBy: false,
        filterOptions: {
          "Renewable Energy Development": {
            value: 1,
            selected: false,
          },
          "Waste Management": {
            value: 2,
            selected: false,
          },
          "Forestry and Conservation": {
            value: 3,
            selected: false,
          },
          "Community Projects": {
            value: 4,
            selected: false,
          },
          "Blue Carbon Projects": {
            value: 5,
            selected: false,
          },
          "Agriculture and Land Management": {
            value: 6,
            selected: false,
          },
          "Capture & Destruction of high potency GHGs": {
            value: 7,
            selected: false,
          },
          "Energy efficiency": {
            value: 8,
            selected: false,
          },
        },
        filterName: "types",
      },
      Program: {
        type: "string",
        hasSortBy: false,
        filterOptions: {
          "Clean Development Mechanism (CDM)": {
            value: 1,
            selected: false,
          },
          "California Compliance Offset Program": {
            value: 2,
            selected: false,
          },
          "Joint Implementation (JI)": {
            value: 3,
            selected: false,
          },
          "Regional Greenhouse Gas Initiative (RGGI)": {
            value: 4,
            selected: false,
          },
          "Alberta Emission Offset Program (AEOP)": {
            value: 5,
            selected: false,
          },
          "American Carbon Registry": {
            value: 6,
            selected: false,
          },
          "Climate Action Reserve (CAR)": {
            value: 7,
            selected: false,
          },
          "The Gold Standard": {
            value: 8,
            selected: false,
          },
          "Plan Vivo": {
            value: 9,
            selected: false,
          },
          "The Verified Carbon Standard": {
            value: 10,
            selected: false,
          },
        },
        filterName: "program",
      },
      "Available offset Amount": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      "Total offset Amount": {
        type: "string",
        hasSortBy: true,
        filterOptions: {},
      },
      Status: {
        type: "string",
        hasSortBy: false,
        filterOptions: {
          Hold: {
            value: 1,
            selected: false,
          },
          "Retired-Partially": {
            value: 2,
            selected: false,
          },
          "Retired-Fully": {
            value: 3,
            selected: false,
          },
          Transferred: {
            value: 4,
            selected: false,
          },
        },
        filterName: "statusFilter",
      },
    },
  });
  const [detailedSelectIndex, setDetailedSelectIndex] = useState(0);
  const [detailedSelectItem, setDetailedSelectItem] = useState({} as any);
  const [detailedSelectRefresh, setDetailedSelectRefresh] = useState(false);
  const navigate = useNavigate();
  const addNewOffset = () => {
    const bunitList = localStorage.getItem("businessUnits");
    !bunitList?.length
      ? toastMessage("Create a facility first for creating an offset", "error")
      : navigate("/offset");
  };

  const [openTableFilterSort, setOpenTableFilterSort] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState<any>();
  const showOffsetFilterOptions = (columnName: any) => {
    if (columnName in controller.columns) {
      let selectedColumnData = controller.columns[columnName];
      if (
        selectedColumnData.hasSortBy &&
        Object.keys(selectedColumnData?.filterOptions)?.length === 0
      ) {
        const filterController: any = {
          sortBy: columnName,
        };
        if (controller.sortBy === columnName) {
          filterController["sortOrder"] =
            controller.sortOrder === "ASC" ? "DESC" : "ASC";
        } else {
          filterController["sortOrder"] = "ASC";
        }
        handleFilterAndSort(filterController, true);
      } else {
        selectedColumnData["columnName"] = columnName;
        selectedColumnData["sortBy"] = controller.sortBy;
        selectedColumnData["sortOrder"] = controller.sortOrder;
        setSelectedColumnData(selectedColumnData);
        setOpenTableFilterSort(true);
      }
    }
  };

  const handleFilterAndSort = (filterController: any, directSort: boolean) => {
    const updatedController = {
      ...controller,
      page: 0,
    };
    if (filterController.sortBy && filterController.sortOrder) {
      updatedController.sortBy = filterController.sortBy;
      updatedController.sortOrder = filterController.sortOrder;
    }
    if (filterController.selectedFilters?.length) {
      updatedController.filters[selectedColumnData.columnName] =
        filterController.selectedFilters;
    } else if (
      !directSort &&
      selectedColumnData &&
      updatedController.filters[selectedColumnData.columnName]
    ) {
      delete updatedController.filters[selectedColumnData.columnName];
    }
    setController({ ...updatedController });
    setOpenTableFilterSort(false);
  };

  useEffect(() => {
    const reqObj: any = {
      controller: controller,
      filter: {},
    };

    if (Object.keys(controller?.filters).length > 0) {
      Object.entries(controller?.filters).forEach(
        ([filterKey, filterValues]: any) => {
          if (filterValues.length) {
            const filterName =
              controller.columns[filterKey]?.filterName || filterKey;
            let filterValuesString: string = filterValues?.join(",");
            if (filterName === "status") {
              filterValuesString = filterValuesString
                .replace("InActive", "true")
                .replace("Active", "false");
            }
            reqObj.filter[filterName] = filterValuesString;
          }
        }
      );
    }

    searchText !== "" && (reqObj.searchText = searchText);
    setIsLoading(true);
    getOffsetListService(reqObj)
      .then((res) => {
        const offsetsList = res.data.offsets;
        setOffsetsList([...offsetsList]);
        setOffsetsCount(res.data.total_count);
        setDetailedSelectItem(() => offsetsList[detailedSelectIndex]);
      })
      .catch((e) => {
        console.log(e.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [controller, searchText, currentBusinessUnit]);

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  let cellColumns = [
    "Project Id",
    "Project type",
    "Program",
    "Available offset Amount",
    "Total offset Amount",
    "Status",
  ];

  const [statusOptions, setStatusOptions] = useState<any>({
    Hold: ["Retire-Partially", "Retire-Fully", "Transfer"],
    "Retired-Partially": ["Retire-Partially", "Retire-Fully", "Transfer"],
  });

  const onSelectOffset = (e: any, index: number) => {
    setMode(MODE.SELECTED);
    setDetailedSelectIndex(index);
    setDetailedSelectItem(offsetsList[index]);
  };

  const navigateNext = (increment: number, pageIncrement: number) => {
    if (pageIncrement) {
      setController((prevState: any) => {
        return { ...prevState, page: prevState.page + pageIncrement };
      });
      setDetailedSelectIndex(() =>
        pageIncrement === -1 ? controller.limit - 1 : 0
      );
    } else if (increment) {
      setDetailedSelectItem(() => offsetsList[detailedSelectIndex + increment]);
      setDetailedSelectIndex((prevIndex) => prevIndex + increment);
    }
  };

  const onClose = () => {
    setMode(MODE.PLAIN);
  };

  const [openUpdate, setOpenUpdate] = useState(false);
  const [fromDetailedView, setDetailedView] = useState(false);
  const handleStatusChange = (
    e: any,
    eachOffset: any,
    listIndex: any,
    fromDetailedView: boolean
  ) => {
    setEachOffsetData({ ...eachOffset });
    setStatusUpdateSelectedIndex(eachOffset.id);
    setStatusUpdateSelectedListIndex(listIndex);
    setToStatus(e);
    setOpenUpdate(true);
    if (fromDetailedView) {
      setDetailedView(true);
    }
  };

  useEffect(() => {
    if (!openUpdate && mode === MODE.SELECTED) {
      setDetailedSelectRefresh(!detailedSelectRefresh);
    }
  }, [openUpdate]);

  return (
    <Fragment>
      {!offsetsList?.length &&
        searchText === "" &&
        !isLoading &&
        !Object.keys(controller.filters).length && (
          <div className="pw-empty-page flex flex-col h-100v w-full justify-center items-center gap-5">
            <img
              className="pw-no-items"
              src="assets/images/empty.png"
              alt=" "
            />
            <div>{t("Welcome to Offsets")}</div>
            {checkPermissions(["CREATE_OFFSET"], permissions) ? (
              <div className="pw-add-new-bunit" onClick={addNewOffset}>
                <AddBoxIcon className="pw-box-icon" /> <span>{t("New")}</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}

      {(offsetsList?.length ||
        searchText !== "" ||
        isLoading ||
        Object.keys(controller.filters).length) &&
      mode === MODE.PLAIN ? (
        <div className="pw-blist-main overflow-y-auto h-full w-full">
          <div className="pw-blist-header w-full flex flex-row justify-between">
            {/* <FormControl  }} variant="outlined"> */}
            {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder={t("Search")}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              // onKeyDown={(event) => {
              //   if (event.key === "Enter") {
              //     onClickSearch();
              //   }
              // }}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      edge="end"
                      onClick={() => {
                        setSearchText("");
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {/* </FormControl>  */}

            <>
              {checkPermissions(["CREATE_OFFSET"], permissions) ? (
                <div className="pw-add-new-bunit" onClick={addNewOffset}>
                  <AddBoxIcon className="pw-box-icon" /> <span>{t("New")}</span>
                </div>
              ) : (
                ""
              )}
            </>
          </div>
          {isLoading ? (
            <SkeletonLoader type="text" cells={cellColumns} />
          ) : (
            <Fragment>
              {offsetsList?.length || Object.keys(controller.filters).length ? (
                <div className="h-70v pw-hide-scroll overflow-y-auto">
                  <Card>
                    <Table size="small">
                      <TableHead>
                        <TableRow className="h-14">
                          {cellColumns.map((eachCell: any, index) => (
                            <TableCell
                              key={index}
                              className={`bg-neutral-50 whitespace-nowrap overflow-hidden ${
                                controller.sortBy === eachCell ||
                                (controller.filters[eachCell] &&
                                  Object.keys(controller.filters[eachCell])
                                    ?.length)
                                  ? "!bg-neutral-200 cursor-pointer"
                                  : controller?.columns?.[eachCell] &&
                                    offsetsList?.length
                                  ? "pw-head-bunit-bg cursor-pointer"
                                  : ""
                              } pw-thead-list`}
                              id={eachCell + "-th"}
                              onClick={() => {
                                return offsetsList?.length
                                  ? showOffsetFilterOptions(eachCell)
                                  : Object.keys(controller.filters[eachCell])
                                      ?.length
                                  ? showOffsetFilterOptions(eachCell)
                                  : "";
                              }}
                            >
                              <div className="flex flex-row items-center gap-1">
                                {
                                  <Tooltip
                                    title={`${
                                      offsetsList?.length
                                        ? controller?.columns?.[eachCell] &&
                                          Object.keys(
                                            controller?.columns?.[eachCell]
                                              ?.filterOptions
                                          )?.length
                                          ? "Filter by " + eachCell
                                          : controller?.columns?.[eachCell]
                                              ?.hasSortBy
                                          ? "Sort by " + eachCell
                                          : ""
                                        : ""
                                    }`}
                                    arrow={false}
                                    placement="bottomLeft"
                                  >
                                    <div>{eachCell}</div>
                                  </Tooltip>
                                }

                                {eachCell != " " &&
                                  controller.sortBy === eachCell &&
                                  (controller.sortOrder === "ASC" ? (
                                    <Tooltip
                                      title={`${
                                        offsetsList?.length
                                          ? "Ascending Order - Click to sort in descending order"
                                          : ""
                                      }`}
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title="Descending Order - Click to sort in ascending order"
                                      placement="bottomLeft"
                                      arrow={false}
                                    >
                                      <ArrowDownwardIcon
                                        sx={{ fontSize: 16 }}
                                      />
                                    </Tooltip>
                                  ))}
                                {controller?.columns?.[eachCell] &&
                                Object.keys(
                                  controller?.columns?.[eachCell]?.filterOptions
                                )?.length ? (
                                  <img
                                    src="assets/icons/filter-variant.svg"
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {offsetsList?.length ? (
                        <TableBody>
                          {offsetsList.map((eachOffset: any, index: number) => (
                            <TableRow
                              key={eachOffset.id}
                              onClick={(e) => onSelectOffset(e, index)}
                              className="bg-white h-14 cursor-pointer hover:bg-neutral-100"
                            >
                              <TableCell> {eachOffset.project_id} </TableCell>
                              <TableCell>
                                {" "}
                                {eachOffset.project_type || "-"}{" "}
                              </TableCell>
                              <TableCell>
                                {" "}
                                {eachOffset.program || "-"}{" "}
                              </TableCell>
                              <TableCell>
                                {" "}
                                {eachOffset.active_value}
                                {" (" + eachOffset.uom_name + ")"}{" "}
                              </TableCell>
                              <TableCell>
                                {" "}
                                {eachOffset.value || "-"}
                                {" (" + eachOffset.uom_name + ")"}{" "}
                              </TableCell>
                              <TableCell
                                onClick={(e) =>
                                  eachOffset.credit_status === "Hold" ||
                                  eachOffset.credit_status ===
                                    "Retired-Partially"
                                    ? e.stopPropagation()
                                    : ""
                                }
                              >
                                {" "}
                                {/* {eachOffset.credit_status || "-"}{" "} */}
                                {checkPermissions(
                                  ["UPDATE_OFFSET_STATUS"],
                                  permissions
                                ) &&
                                (eachOffset.credit_status === "Hold" ||
                                  eachOffset.credit_status ===
                                    "Retired-Partially") ? (
                                  <AntSelect
                                    placeholder="Please select"
                                    dropdownStyle={{
                                      minWidth: "12rem",
                                      paddingRight: "12px",
                                    }}
                                    suffixIcon={
                                      <CaretDownOutlined className="!pointer-events-none" />
                                    }
                                    value={eachOffset?.credit_status}
                                    className={`pw-offset-status-selection pw-${eachOffset.credit_status.toLowerCase()}`}
                                    onChange={(event: any) => {
                                      handleStatusChange(
                                        event,
                                        eachOffset,
                                        index,
                                        false
                                      );
                                    }}
                                  >
                                    {statusOptions[
                                      eachOffset.credit_status
                                    ]?.map((name: any, index: number) => {
                                      return (
                                        <Option
                                          value={name}
                                          className={` pw-margin-10 font-bold pw-${name.toLowerCase()}`}
                                        >
                                          {name}
                                        </Option>
                                      );
                                    })}
                                  </AntSelect>
                                ) : (
                                  <div
                                    className={`pw-${eachOffset.credit_status.toLowerCase()} pw-offset-status-list`}
                                  >
                                    {eachOffset.credit_status}
                                  </div>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      ) : (
                        " "
                      )}
                    </Table>
                  </Card>
                  {!offsetsList?.length ? (
                    <div className="flex justify-center items-center h-full bg-white">
                      No results found
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <EmptyList cellColumns={cellColumns} />
              )}
              {offsetsCount >= 10 && (
                <TablePagination
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={offsetsCount}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Fragment>
          )}
        </div>
      ) : (
        ""
      )}

      {(offsetsList?.length || searchText !== "") && mode === MODE.SELECTED ? (
        <div className="pw-blist-main-selected  h-90v flex flex-row">
          <div className="flex flex-col w-1/3 bg-neutral-200 pw-width-side">
            <div className="h-full pw-select-side-list overflow-y-auto flex flex-col w-45 gap-px">
              <div className="flex flex-row justify-between pw-padding-side-2 gap-4">
                <OutlinedInput
                  id="outlined-adornment-password "
                  className="pw-search-field pw-search-field-2"
                  placeholder={t("Search")}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      // onClickSearch();
                    }
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {searchText === "" ? (
                        <IconButton
                          // onClick={onClickSearch}
                          edge="end"
                        >
                          <SearchIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            setSearchText("");
                          }}
                          edge="end"
                        >
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
                {checkPermissions(["CREATE_OFFSET"], permissions) ? (
                  <div className="pw-add-new-bunit" onClick={addNewOffset}>
                    <AddBoxIcon className="pw-box-icon" />{" "}
                    <span>{t("New")}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {offsetsList?.length ? (
                offsetsList.map((eachOffset: any, index: number) => (
                  <div
                    className={`flex flex-row cursor-pointer pw-bunitlist-card ${
                      detailedSelectItem?.id === eachOffset.id
                        ? "bg-neutral-100"
                        : "bg-white"
                    }`}
                    key={eachOffset.id}
                    onClick={(e) => onSelectOffset(e, index)}
                  >
                    <div className="flex flex-col justify-center">
                      <div className="pw-bunit-name font-medium text-sm ">
                        {eachOffset.project_name}
                      </div>
                      <div className="pw-bunit-incharge text-neutral-600 text-sm">
                        {eachOffset.project_type}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <EmptyList />
              )}
            </div>

            {offsetsCount >= 10 ? (
              <TablePagination
                component="div"
                count={offsetsCount}
                page={controller.page}
                colSpan={5}
                onPageChange={handlePageChange}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                className="flex flex-row justify-end"
              />
            ) : (
              ""
            )}
          </div>
          {offsetsList?.length ? (
            <ProjectsAndOffsetsDetailedView
              offsetData={detailedSelectItem}
              currentIndex={detailedSelectIndex}
              controller={controller}
              total_count={offsetsCount}
              detailedSelectRefresh={detailedSelectRefresh}
              navigateNext={navigateNext}
              setController={setController}
              onClose={onClose}
              handleStatusChange={handleStatusChange}
            />
          ) : (
            <EmptyList detailedView={true} />
          )}
        </div>
      ) : (
        ""
      )}
      {openUpdate && (
        <ProjectsAndOffsetsStatusUpdate
          setEachOffsetData={setEachOffsetData}
          eachOffsetData={eachOffsetData}
          statusUpdateSelectedIndex={statusUpdateSelectedIndex}
          statusUpdateSelectedListIndex={statusUpdateSelectedListIndex}
          toStatus={toStatus}
          setToStatus={setToStatus}
          setOffsetsList={setOffsetsList}
          offsetsList={offsetsList}
          updateStatusFormData={updateStatusFormData}
          setUpdateStatusFormData={setUpdateStatusFormData}
          setOpenUpdate={setOpenUpdate}
          openUpdate={openUpdate}
          fromDetailedView={fromDetailedView}
        />
      )}
      {openTableFilterSort && (
        <TableFilterSort
          selectedColumnData={selectedColumnData}
          openTableFilterSort={openTableFilterSort}
          setOpenTableFilterSort={setOpenTableFilterSort}
          handleFilterAndSort={handleFilterAndSort}
          filter={controller.filters}
        />
      )}
    </Fragment>
  );
};

export default ProjectAndOffsetsList;
